import { Text as MantineText, TextProps } from '@mantine/core'
import { ReactNode } from 'react'

type Props = TextProps & { children?: ReactNode }

export const Text = (props: Props) => <MantineText {...props} />
